import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Prišlo je do napake. Poskusite znova.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message && !e.response ? fallback : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Preverite vnesene podatke.";
  return fallback;
}

export const fileUrl = (p) => (p ? `${BACKEND}${p}` : null);

const MONTHS = ["januar", "februar", "marec", "april", "maj", "junij", "julij", "avgust", "september", "oktober", "november", "december"];
export function slDate(iso) {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return `${d}. ${MONTHS[m - 1]} ${y}`;
}
export function slDateShort(iso) {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}. ${m}. ${y}`;
}
export function slDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("sl-SI", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function fmtBytes(b = 0) {
  if (b < 1024) return `${b} B`;
  const u = ["KB", "MB", "GB", "TB"];
  let i = -1;
  do { b /= 1024; i++; } while (b >= 1024 && i < u.length - 1);
  return `${b.toFixed(b < 10 ? 1 : 0).replace(".", ",")} ${u[i]}`;
}

export function plural(n, one, two, few, many) {
  const m = n % 100;
  if (m === 1) return one;
  if (m === 2) return two;
  if (m === 3 || m === 4) return few;
  return many;
}
export const photosLabel = (n) => `${n} ${plural(n, "fotografija", "fotografiji", "fotografije", "fotografij")}`;
export const videosLabel = (n) => `${n} ${plural(n, "video", "videa", "videi", "videov")}`;
export const guestsLabel = (n) => `${n} ${plural(n, "gost je delil", "gosta sta delila", "gostje so delili", "gostov je delilo")} spomine`;

export const STATUS = {
  aktivna: "Aktivna", prihajajoca: "Prihajajoča", caka_placilo: "Čaka na plačilo", odlog: "V obdobju odloga", potekla: "Potekla",
};
export const PAYMENT = { neplacano: "Neplačano", caka_nakazilo: "Čaka na nakazilo", placano: "Plačano", vrnjeno: "Vračilo plačila", preklicano: "Preklicano" };

export function uuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return "g-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function guestIdentity(slug) {
  const key = `wqr_token_${slug}`;
  let token = localStorage.getItem(key);
  if (!token) { token = uuid(); localStorage.setItem(key, token); }
  return token;
}
export const getGuestName = () => localStorage.getItem("wqr_name") || "";
export const setGuestName = (n) => localStorage.setItem("wqr_name", n.trim());

export function uploadFile(slug, file, name, token, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${BACKEND}/api/public/w/${slug}/upload`);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress(e.loaded / e.total);
    xhr.onload = () => {
      if (xhr.status < 300) return resolve(JSON.parse(xhr.responseText));
      let d;
      try { d = JSON.parse(xhr.responseText).detail; } catch (_) { d = null; }
      const er = new Error(typeof d === "string" ? d : "Nalaganje ni uspelo.");
      er.status = xhr.status;
      reject(er);
    };
    xhr.onerror = () => { const er = new Error("Povezava je bila prekinjena."); er.status = 0; reject(er); };
    xhr.ontimeout = xhr.onerror;
    const fd = new FormData();
    fd.append("file", file);
    fd.append("name", name);
    fd.append("guest_token", token);
    xhr.send(fd);
  });
}

export async function downloadBlob(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function shareLink(url, title) {
  if (navigator.share) {
    try { await navigator.share({ title, url }); return "shared"; } catch (_) { return "cancel"; }
  }
  await navigator.clipboard.writeText(url);
  return "copied";
}
